// extracted by mini-css-extract-plugin
module.exports =  {"container":"last_articles_container-module_container_d7483","list":"last_articles_container-module_list_d5544","title":"last_articles_container-module_title_fa1c4"};